import { render, staticRenderFns } from "./QuestionTypes.vue?vue&type=template&id=a9c7f912&scoped=true"
import script from "./QuestionTypes.vue?vue&type=script&lang=js"
export * from "./QuestionTypes.vue?vue&type=script&lang=js"
import style0 from "./QuestionTypes.vue?vue&type=style&index=0&id=a9c7f912&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9c7f912",
  null
  
)

export default component.exports